// Invoice내역 > 배송운임
import { invoiceDeliveryChargeFieldPack, invoiceDeliveryChargeLocalePack, } from '@/constants/salesFieldPack';
import { beforeDays } from '@/utils/time';
import { format } from 'date-fns';
import dateFormatType from '@/constants/dateFormatType';
import AbsSales from './AbsSales';
export default class InvoiceDeliveryCharge extends AbsSales {
    resourceType = 'hub';
    dateType = 'daily';
    date = [];
    graphName = '그래프';
    graphSubTitle = '허브 바로머니 일별 통계';
    graphCaptureName = '매출_허브_바로머니_일별';
    excelFileName = '매출_허브_바로머니_일별';
    excelSheetName = 'Sheet1';
    excelCellWidth = [
        10,
        25,
        12,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
    ];
    excelHeaderData = [
        [
            invoiceDeliveryChargeLocalePack.orderHub,
            invoiceDeliveryChargeLocalePack.unit,
            invoiceDeliveryChargeLocalePack.count,
            invoiceDeliveryChargeLocalePack.supplyPrice,
            invoiceDeliveryChargeLocalePack.vatIncluded,
            invoiceDeliveryChargeLocalePack.dataCheck,
        ],
    ];
    excelMergeData = [];
    pageHeaderData = [
        {
            title: 'testid',
            value: 'id',
            align: 'center',
            cellAlign: 'ta-c',
            width: 30,
        },
        {
            title: invoiceDeliveryChargeLocalePack.orderHub,
            value: invoiceDeliveryChargeFieldPack.orderHub,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceDeliveryChargeLocalePack.unit,
            value: invoiceDeliveryChargeFieldPack.unit,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceDeliveryChargeLocalePack.count,
            value: invoiceDeliveryChargeFieldPack.count,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceDeliveryChargeLocalePack.supplyPrice,
            value: invoiceDeliveryChargeFieldPack.supplyPrice,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceDeliveryChargeLocalePack.vatIncluded,
            value: invoiceDeliveryChargeFieldPack.vatIncluded,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
        {
            title: invoiceDeliveryChargeLocalePack.dataCheck,
            value: invoiceDeliveryChargeFieldPack.dataCheck,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
        },
    ];
    isGraphConfig = false;
    // eslint-disable-next-line class-methods-use-this
    makeGraphConfig() { }
    /**
     * 초기화 날짜 생성
     * @returns 초기화 날짜
     */
    initDate() {
        this.date = [
            format(beforeDays(new Date(), 1), dateFormatType.DATE),
            format(new Date(), dateFormatType.DATE),
        ];
    }
}
